import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ContactPersonsBlock } from '../../_blocks/ContactPersons';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type ContactPersonsWidget = ContextWidget<ContactPersonsBlock, WidgetType.contactpersons>;

export function ContactPersonsWidget(props: ContactPersonsWidget) {
  const { t } = useSonTranslation('ContactPersons');
  return <DefaultContextWidget icon={Icons.MEMBERS} title={t('widgetTitle')} {...props} />;
}
